<template>
  <div>
    <title-bar :title="$t('navigations.variables')"/>
    <div v-if="variables" class="custom-table">
      <table-actions
        :actions="['perPage']"
        @onSearchInput="inputChange"
        @perPageChange="perPageChange"
        :defaultPerPage="perPage"
      />
      <table-lite
        :is-slot-mode="true"
        :is-loading="isLoading"
        :columns="columns"
        :rows="variables"
        :sortable="{}"
        @is-finished="isLoading = false"
      >
        <template v-slot:name="data">
          <router-link :to="$helper.getEditUrl('variable', data.value.name)">
            {{ $helper.getEnumTranslation("variable", data.value.name, $i18n.locale) }}
          </router-link>
        </template>
        <template v-slot:actions="data">
          <div class="just-buttons">
            <edit-btn :path="$helper.getEditUrl('variable', data.value.name)"/>
          </div>
        </template>
      </table-lite>
      <table-pagination
        v-model="currentPage"
        :total="pages"
        :per-page="perPage"
        @input="onChangePage"
      />
    </div>
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar.vue";
import TableLite from "vue3-table-lite";
import TablePagination from "@/components/Table/TablePagination.vue";
import TableActions from "@/components/Table/TableActions.vue";
import EditBtn from "@/components/Buttons/EditBtn.vue";
import ResourceUtils from "@/mixins/ResourceUtils";

export default {
  components: {
    TableLite,
    TablePagination,
    TableActions,
    EditBtn,
    TitleBar
  },
  mixins: [ResourceUtils],
  data() {
    return {
      search: "",
      isLoading: false,
      variables: null,
      perPage: this.$store.state.defaultPerPage,
      currentPage: 1,
      pages: 0,
      columns: [
        {
          label: this.$t('variable.name'),
          field: "name",
          sortable: false,
        },
        {
          label: this.$t('variable.actions'),
          field: "actions",
          sortable: false,
          width: "120px",
        },
      ],
    };
  },
  created() {
    this.loadVariables();
  },
  methods: {
    loadVariables() {
      const params = {
        itemsPerPage: this.perPage,
        page: this.currentPage
      };
      if (this.search && this.search.length) {
        params.search = this.search;
      }
      this.$Variables.getCollection({params}).then((response) => {
        this.pages = response.data["hydra:totalItems"];
        this.variables = response.data["hydra:member"];
      });
    },
    onChangePage(page) {
      this.currentPage = page;
      this.loadVariables();
    },
    error() {
      this.$emit("clearAction");
    },
    inputChange(value) {
      this.currentPage = 1;
      this.search = value;
      this.loadVariables();
    },
    perPageChange(num) {
      this.currentPage = 1;
      this.perPage = num;
      this.loadVariables();
    },
    onPageChange() {
      this.loadVariables();
    },
  },
};
</script>

<style lang="scss">
</style>
